// extracted by mini-css-extract-plugin
module.exports = {"root":"NavbarMenuItem_root__ZD1dU","border":"NavbarMenuItem_border__bCJVt","active":"NavbarMenuItem_active__7h8A7"};